import type { CompassComponent } from '../../types';

export const isCompassComponent = (entity: any): entity is CompassComponent =>
	entity.__typename === 'CompassComponent';

export const getCompassComponentLink = (component: CompassComponent): string | null =>
	component?.url ?? null;
